import React from "react";
import RadioButtons from "src/components/common/RadioButton";

import styles from "./styles.module.scss";
import CollapsibleMenu from "src/components/common/CollapsibleMenu";
import * as Validators from "src/utils/validators";

const Intermediary = ({ onChange, txType, intermediary, collapsible }) => {
    const body = (
        <div className={[styles.section, styles.quadruplets].join(" ")}>
            {!collapsible && <div className={styles.title}>Intermediary</div>}
            <div className={styles.input}>
                <RadioButtons
                    options={Validators.INTERMEDIARY_SELECT_OPTIONS(txType)}
                    dataTestId="select-intermediary"
                    value={intermediary}
                    setter={onChange}
                />
            </div>
        </div>
    );
    if (collapsible) {
        return (
            <CollapsibleMenu
                title="Intermediary"
                dataTestId="init-intermediary"
            >
                {body}
            </CollapsibleMenu>
        );
    }
    return body;
};

export default Intermediary;
